<template>
	<!-- 목적 :  검색 셀렉트 멀티 셀렉션 -->
	<!-- 예시 : src\views\qms\FreeForm\Content\Search\SearchView.vue  -->
	<div class="sf-input-group-wrapper">
		<template v-if="label">
			<span class="sf-input-group-wrapper__label">{{ label }}</span>
		</template>
		<div class="search-option-wrapper__normal">
			<el-select
				v-model="selectedData"
				multiple
				:placeholder="label"
				clearable
				@change="change"
				:collapse-tags="collapseTags"
				v-bind="{ ...elObject }"
			>
				<template v-if="options.length">
					<template v-if="showAll">
						<el-option :label="getMessage_('QWCC002027')" value="all"></el-option>
					</template>
					<el-option
						v-for="(item, index) in options"
						:label="item.commCdName || item.label"
						:value="item.commCd || item.value"
						:key="index"
					></el-option>
				</template>
			</el-select>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	name: 'multi-select-combo',
	props: {
		label: { default: '' },
		paramKey: { default: '' }, //키 값
		options: {
			default() {
				return [];
			}
		},
		propData: { default: '' },
		initData: { default: '' },
		clearable: { default: true }, //한번에 지우는 기능
		disabled: { type: Boolean, default: false },
		showAll: { type: Boolean, default: true },
		collapseTags: { type: Boolean, default: false },
		elProps: {
			type: Object,
			default: () => {},
			description: 'el-element에서 제공하는 props들 매핑할 수 있는 Props'
		}
	},
	data() {
		return { selectedData: [] };
	},
	watch: {
		initData() {
			this.selectedData = []; //연계 콤보시 첫번째 콤보가 변하면, 두 번째 콤보 값 초기화 설정을 위한 작업
		}
	},
	methods: {
		...rootMethods,
		change(value) {
			const last = _.last(value);
			if (last === 'all') {
				this.selectedData = this.options?.map(opt => opt.commCd || opt.value);
			}
			if (last === 'delete') {
				this.selectedData = [];
			}
			this.$emit('multiCommChange', { key: this.paramKey, value: this.selectedData });
		}
	},
	computed: {
		...rootComputed,
		allData() {
			return '';
		},
		elObject() {
			return this.elProps;
		}
	}
};
</script>

<style lang="scss" scoped></style>
